/**
 * Firebase project configuration.
 * Prefer env vars in production; fallbacks match your Firebase project (arctic-menu).
 */
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? "AIzaSyCOKrpil0Am4orYhqx7YGYbM1_4SNDc4Gk",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? "arctic-menu.firebaseapp.com",
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL ?? "https://arctic-menu-default-rtdb.firebaseio.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? "arctic-menu",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? "arctic-menu.appspot.com",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? "95922122930",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID ?? "1:95922122930:web:e6cc2b851fea7cd40859ab",
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID ?? "G-CRKXBQ256R",
} as const;
